import { Form, Grid, message } from 'antd';
import { Modal } from 'components';
import { useCreateDocuments } from 'features/document-report/use-cases/create-documents';
import { useGetDropDownList } from 'features/document-report/use-cases/drop-down-value';
import { useUserContext } from 'features/users';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import {
  UserFormField,
  UserFormValues,
} from 'features/users/components/users-filter-form';
import { useState } from 'react';
import { convertFileSize } from 'routes/utils';

import { DocumentsInfoFormItems } from './document-info';

const { useBreakpoint } = Grid;

export const AddDocumentsModal = ({
  onClose,
  pendingrefetch,
  month,
  year,
}: {
  onClose: () => void;
  pendingrefetch: any;
  month: any;
  year: any;
}) => {
  const { user } = useUserContext();
  const formName = 'add-user-form';
  const screens = useBreakpoint();
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<UserFormValues>();
  const { data } = useGetDropDownList({
    CompanyId: user?.CompanyId,
    Flag: 'Category',
    ClientId: user?.Id,
  } as any);
  // const { refetch } = useAssignDocuments(user?.CompanyId);
  const [fileList, setFileList] = useState<any[]>([]);
  const [previewImage, setPreviewImage] = useState<string>('');
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);
  const [isImageUploading, setIsImageUploading] = useState<boolean>(false); // Loading state for image upload
  const [fileNames, setFileNames] = useState<any>([]);
  const { isLoading, mutate } = useCreateDocuments();
  const getInitialValues = {
    [UserFormField.Role]: undefined,
    [UserFormField.Email]: undefined,
  };
  const handleUpdate = (formValues: any) => {
    const IsClientUpload = true;
    // const formData = new FormData();
    if (!fileList || fileList.length === 0) {
      message.error('Please upload at least one file.');

      return;
    }
    // Collect files and their blob URLs
    const files = fileList
      .map((fileItem, index) => {
        const file = fileItem.originFileObj;
        const fileSize = file.size;
        const documentName =
          fileList.length > 1
            ? `${formValues.DocumentName || 'Document'} (${index + 1})`
            : formValues.DocumentName || 'Document'; // No index if there's only one file

        if (!file) return null;
        const fileData = {
          documentName,
          fileName: fileNames[index] || '',
          fileSize: convertFileSize(fileSize),
          // blobUrl: blobUrl,  // Add blobUrl for each file
        };

        return fileData;
      })
      .filter((file) => file !== null);

    const payload = {
      companyId: user?.CompanyId,
      periodId: 0,
      // documentId: id,
      serviceId:
        formValues.class || formValues.SubCategory || formValues.category || 0,
      isClientUpload: IsClientUpload,
      files: files, // Send files with their blob URLs
      year: +year,
      month: +month,
    };
    mutate(payload, {
      onSuccess: () => {
        onClose();
        pendingrefetch();
      },
    });
  };

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        centered
        title={<span className='font-semibold'>Upload Documents</span>}
        onCancel={onClose}
        getContainer={false}
        onOk={form.submit}
        okText={'Upload'}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={screens.lg ? '520px' : '100%'}
        okButtonProps={{
          form: formName,
          loading: isLoading,
          disabled: isImageUploading,
        }}
        maskClosable={false}
      >
        <Form<UserFormValues>
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          initialValues={getInitialValues}
          onFinish={handleUpdate}
          onFinishFailed={() => {
            setValidateTrigger(['onChange']);
          }}
          validateTrigger={validateTrigger}
          disabled={isLoading}
          requiredMark={true}
        >
          <DocumentsInfoFormItems
            data={data}
            // isFetching={isFetching}
            setFileList={setFileList}
            setPreviewImage={setPreviewImage}
            setPreviewOpen={setPreviewOpen}
            fileList={fileList}
            previewImage={previewImage}
            previewOpen={previewOpen}
            setIsImageUploading={setIsImageUploading}
            setFileNames={setFileNames}
            isImageUploading={isImageUploading}
          />
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
